const prefix = "edcForms";

export const SAVE_FORM_ERRORS = `${prefix}/SET_FORM_ERROR`;

export default prefix;
